import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  TextField,
  Stack,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getPaymentHostDetails } from "../../../services/payment";
import Label from "../../../components/Label";
import { parseDate } from "../../../utils/tableFunctions";
import { Clear } from "@mui/icons-material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import HeaderHelpPage from "../../../components/HeaderHelpPage";
import { styles } from "../../../utils/styles";

const PaymentHostDetails = ({ itemId }) => {
  const [hostDetails, sethostDetails] = useState();
  const [loaded, setLoaded] = useState();
  const [mask, setMask] = useState(true);
  const { id = itemId } = useParams();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const action = useQuery().get("action");
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  useEffect(() => {
    getPaymentHostDetails(id, sethostDetails, setLoaded);
  }, [action, id]);

  const handleBack = () => window.close();

  return (
    <Container>
      {!itemId && (
        <Stack
          direction="row"
          sx={{
            ...styles.flexBetween,
            mb: 2,
          }}
        >
          <HeaderHelpPage title="Payment Host Details" variant={mobile ? "h5" : "h3"} />

          <Button
            variant="outlined"
            onClick={handleBack}
            endIcon={<Clear />}
          >
            Back
          </Button>
        </Stack>
      )}
      {loaded && action === "true" && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          Action: {hostDetails.action}
        </Typography>
      )}
      {loaded ? (
        <Card sx={{ p: 3 }}>
          <Grid container direction="row" spacing={2} sx={{ p: 3 }}>
            <Grid container xs={6} direction="row" spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" align="right">
                  Payment Host Name
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {hostDetails.payment_host.name}
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" align="right">
                  Allowed Currency
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {hostDetails.currency.length === 0
                  ? ""
                  : hostDetails.currency
                      .map(({ id, currency }) => `${currency}`)
                      .join(", ")}
              </Grid>
            </Grid>
            <Grid container xs={6} direction="row" spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" align="right">
                  Active Now
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Label
                  variant="ghost"
                  color={
                    hostDetails.payment_host.is_active ? "success" : "error"
                  }
                >
                  {hostDetails.payment_host.is_active ? "YES" : "NO"}
                </Label>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" align="right">
                  Created on
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {parseDate(hostDetails.payment_host.created_at)}
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" align="right">
                  Updated on
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {parseDate(hostDetails.payment_host.updated_at)}
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid
            container
            spacing={2}
            justifyContent="center"
            maxWidth="60%"
            sx={{ mx: "auto", mt: 5 }}
          >
            <Box width={"100%"} justifyContent="center" display="flex">
              {/* <Typography variant="subtitle1">Host details</Typography> */}
              <Button
                sx={{ mx: "auto" }}
                onClick={() => setMask(!mask)}
                endIcon={mask ? <VisibilityOff /> : <Visibility />}
                variant="outlined"
              >
                Reveal Details
              </Button>
            </Box>
            {Object.entries(JSON.parse(hostDetails.data)).map(
              ([key, value]) => (
                <>
                  <Grid item xs={3}>
                    <Typography 
                      variant="subtitle1"
                      align="right"
                      sx={{ wordBreak: 'break-all' }}
                    >
                      {key}
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl fullWidth>
                      <TextField
                        hiddenLabel
                        disabled
                        defaultValue={value}
                        variant="filled"
                        size="small"
                        type={mask ? "password" : "text"}
                      />
                    </FormControl>
                  </Grid>
                </>
              )
            )}
          </Grid>
        </Card>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default PaymentHostDetails;
